module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-5.5af6aa15.png";